var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDrillingWaste = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 15,
  viewBox: "0 0 20 15",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19 13.5H1V1.5H2.5L3.5 3H16.5L17.5 1.5H19V13.5Z",
  stroke: "currentcolor",
  strokeWidth: 2,
  fill: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 5.5V11",
  stroke: "currentcolor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M7 5.5V11",
  stroke: "currentcolor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M10 5.5V11",
  stroke: "currentcolor"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M13 5.5V11",
  stroke: "currentcolor"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M16 5.5V11",
  stroke: "currentcolor"
})));
export { SvgDrillingWaste as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDIwIDE1IiBmaWxsPSJub25lIj4KICAgIDxwYXRoIGQ9Ik0xOSAxMy41SDFWMS41SDIuNUwzLjUgM0gxNi41TDE3LjUgMS41SDE5VjEzLjVaIiBzdHJva2U9ImN1cnJlbnRjb2xvciIgIHN0cm9rZS13aWR0aD0iMiIgZmlsbD0ibm9uZSIvPgogICAgPHBhdGggZD0iTTQgNS41VjExIiBzdHJva2U9ImN1cnJlbnRjb2xvciIvPgogICAgPHBhdGggZD0iTTcgNS41VjExIiBzdHJva2U9ImN1cnJlbnRjb2xvciIvPgogICAgPHBhdGggZD0iTTEwIDUuNVYxMSIgc3Ryb2tlPSJjdXJyZW50Y29sb3IiLz4KICAgIDxwYXRoIGQ9Ik0xMyA1LjVWMTEiIHN0cm9rZT0iY3VycmVudGNvbG9yIiAvPgogICAgPHBhdGggZD0iTTE2IDUuNVYxMSIgc3Ryb2tlPSJjdXJyZW50Y29sb3IiIC8+Cjwvc3ZnPgo=";